/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：697
 */

"use strict"

function r(e, t) {
  if ("function" === typeof e) {
    e(t)
  } else {
    if (e) {
      e.current = t
    }
  }
}
export { r as a }
export default r
